import images from 'assets/images/images';
import useClickOutside from 'hooks/useClickOutside';
import React, {useRef, useState} from 'react'

const Dropdown = ({dropdownList, onSelect, disabled, placeholder='Seçim Yap', value=''}) => {
    const [isOpen, setIsOpen] = useState(false)
    const dropdownContainerRef = useRef(null);
    useClickOutside(dropdownContainerRef, () => {
        setIsOpen(false);
      });
      console.log(value,'value')
  return (
    <div ref={dropdownContainerRef} className='select-dropdown'>
        <div className={`select-dropdown-label ${disabled ? 'disabled': ''}`} onClick={() => {
            if (!disabled) {
                setIsOpen(true)
            }
        }}>
            <span>{value ? value.name : placeholder}</span> <img src={images.dropdownSelect} alt="dropdonw icon" />
        </div>
        {
            isOpen &&  <div className="select-dropdown-list">
                {dropdownList.map(item => (
                    <div key={item.id} onClick={() => {
                        onSelect(item)
                        setIsOpen(false);
                    }} className="select-dropdown-list-item">{item.name} {item.isChildMenu && <img className='sticker' src={images.cocukDunyasi} />}</div>
                ))}
            </div>
        }
    </div>
  )
}

export default Dropdown